import { TranslationKeysByPath } from '@/localization';
import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { UnifiedProfileSectionHeader } from './UnifiedProfileSectionHeader';

type UnifiedProfileSectionProps = { header?: TranslationKeysByPath<'unifiedProfile'>; headerIcon?: ReactNode } & ComponentPropsWithoutRef<'article'>;

export const UnifiedProfileSection: FC<UnifiedProfileSectionProps> = ({ header, headerIcon, className, children, ...rest }) => {
  return (
    <article className={twMerge('flex flex-col gap-2', className)} {...rest}>
      {header && <UnifiedProfileSectionHeader labelKey={header} icon={headerIcon} />}
      {children}
    </article>
  );
};
